// src/pages/NotificationManagement/components/NotificationFilterTabs.tsx
// Tab lọc theo loại thông báo (Tất cả / Khẩn cấp / Cảnh báo / Xác nhận / Thông tin)
// Theo mục 3.2 của .features/thong-bao/ke_hoach_ui_man_thong_bao.md

import React from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('notification_management');

export type FilterTabKey = 'all' | 'urgent' | 'warning' | 'confirm' | 'info';

export type FilterTabCounts = Record<FilterTabKey, number>;

interface NotificationFilterTabsProps {
  activeTab: FilterTabKey;
  onChange: (tab: FilterTabKey) => void;
  counts: FilterTabCounts;
}

const TABS: { key: FilterTabKey; label: string }[] = [
  { key: 'all', label: st('tat_ca_label') },
  { key: 'urgent', label: st('khan_cap_label') },
  { key: 'warning', label: st('canh_bao_label') },
  { key: 'confirm', label: st('xac_nhan_label') },
  { key: 'info', label: st('thong_tin_label') },
];

const NotificationFilterTabs: React.FC<NotificationFilterTabsProps> = ({ activeTab, onChange, counts }) => {
  return (
    <Nav pills className="flex-wrap gap-1">
      {TABS.map((tab) => (
        <NavItem key={tab.key}>
          <NavLink
            href="#"
            className={classnames({ active: activeTab === tab.key })}
            onClick={(e) => { e.preventDefault(); onChange(tab.key); }}
          >
            {tab.label} ({counts[tab.key]})
          </NavLink>
        </NavItem>
      ))}
    </Nav>
  );
};

export default NotificationFilterTabs;
